// import React from 'react';
// import { inject, observer } from 'mobx-react';
//
// import Constraint from 'js/components/Constraint';
// import Modal from 'js/components/core/Modal';
//
// import Title from 'js/components/core/SteppedPage/Title';
// import SubTitle from 'js/components/core/SteppedPage/SubTitle';
// import StepStatus from 'js/components/core/SteppedPage/StepStatus';
// import ProgressRow from 'js/components/core/SteppedPage/ProgressRow';
// import ContinueButton from 'js/components/core/SteppedPage/ContinueButton';
// import Backdrop from 'js/components/core/Backdrop';
// import AddButton, { buttonHeight } from 'js/components/core/SteppedPage/AddButton';
//
// import Form from './Form';
// import Display from './Display';
//
// export default inject('page')(
//   observer(({ page }) => {
//     const showDisplay = page.address.hasAddress;
//     const contentOffset = showDisplay ? `2.5rem` : `${buttonHeight / 2}rem`;
//     return (
//       <>
//         <Backdrop offset={contentOffset}>
//           <Constraint>
//             <Title>Delivery address</Title>
//             <SubTitle>This is the address your items will get delivered to.</SubTitle>
//           </Constraint>
//         </Backdrop>
//
//         <Constraint offset={contentOffset}>
//           {showDisplay ? (
//             <Display />
//           ) : (
//             <AddButton autoFocus onClick={page.openModal}>
//               Add a delivery address
//             </AddButton>
//           )}
//           <ProgressRow>
//             <ContinueButton autoFocus={showDisplay} onClick={page.nextStep}>
//               Continue
//             </ContinueButton>
//             <StepStatus />
//           </ProgressRow>
//         </Constraint>
//
//         <Modal showModal={page.modalIsVisible} onCancel={page.closeModal} withCloseButton>
//           <Form />
//         </Modal>
//       </>
//     );
//   }),
// );
import React from 'react';
import { observer, inject } from 'mobx-react';
import { AvForm } from 'availity-mobx-reactstrap-validation';

import Backdrop from 'js/components/core/Backdrop';
import ContinueButton, { buttonHeight } from 'js/components/core/SteppedPage/ContinueButton';

import AppContent from "js/components/AppContent";
import NameEntry from "js/components/pages/BuyerSignupPage/FullName/NameEntry";
import AddressInput from "js/components/common/AddressInput";

export default inject('page')(
  observer(({ page }) => {
    const buttonOffset = buttonHeight / 2;
    const contentOffset = !page.hasEnteredFullName ? `${buttonOffset + 1.5}rem` : `${buttonOffset}rem`;
    const step1Img = '/images/v2/sellers/rectangle-horizontal.png';
    const step2Img = '/images/v2/sellers/rectangle-horizontal.png';
    const step3Img = '/images/v2/sellers/rectangle-horizontal-grey.png';
    console.log("Page: ",page);

    return (
      <>
        <AppContent className="seller-items-page tw-bg-white" padded>
          <Backdrop offset={contentOffset}>
            <div className="pod-container" style={{padding: "0 1.5rem"}}>
              <div className="tw-flex tw-flex-wrap justify-content-between tw-w-full tw-gap-4 tw-mt-4 tw-mb-3">
                <div className="tw-lg-w-1/2 tw-flex-start tw-flex-auto">
                  <div className="tw-flex tw-mb-8">
                    <span>
                        <div className="tw-flex tw-gap-2 justify-content-between">
                          <span>
                          <img
                            src={`${step1Img}`}
                            alt="step 1"
                            style={{height: '4px', width: '90%'}}
                            className="tw-h-[4px] tw-w-[90%]"
                          />
                        </span>
                        <span>
                        <img
                          src={`${step2Img}`}
                          alt="step 2"
                          style={{height: '4px', width: '90%'}}
                          className="md:tw-hidden tw-h-[4px] md:tw-w-[155.67px] tw-w-[90%]"
                        />
                        <img
                          src={`${step2Img}`}
                          alt="step 2"
                          style={{height: '4px', width: '155.67px'}}
                          className="tw-hidden md:tw-block tw-h-[4px] md:tw-w-[155.67px] tw-w-[90%]"
                        />
                        </span>
                        <span>
                        <img
                          src={`${step3Img}`}
                          alt="step 3"
                          style={{height: '4px', width: '90%'}}
                          className="md:tw-hidden tw-h-[4px] md:tw-w-[155.67px] tw-w-[90%]"
                        />
                        <img
                          src={`${step3Img}`}
                          alt="step 3"
                          style={{height: '4px', width: '155.67px'}}
                          className="tw-hidden md:tw-block tw-h-[4px] md:tw-w-[155.67px] tw-w-[90%]"
                        />
                        </span>
                        </div>
                    </span>
                  </div>
                  <span className="flex-start" style={{font:'inter', fontWeight:'700', fontSize:'17px', lineHeight:'27px'}}>Where do you want your items delivered to?</span>
                  <div className="md:tw-pr-20 tw-mt-8">
                    <AvForm onValidSubmit={page.nextDetail}>
                      <div className="tw-mt-5">
                        <p className='tw-mb-2'>Address</p>
                        <AddressInput
                          name="address"
                          showError={page.hasAddressError}
                          address={page.address}
                          onChange={page.addressSaved}
                          placeholder="Enter your street address"
                          flat={false}
                          className="tw-w-full"
                        />

                        {page.address.address1 && (
                          <div className="tw-flex tw-mt-1" style={{height:'17px', fontSize:'14px', fontWeight:'400'}}>
                            <label htmlFor="defaultAddress" style={{height:'17px', fontSize:'14px', fontWeight:'400'}}>This is the address your items will get delivered to.</label>
                          </div>
                        )}
                      </div>
                      <div className="tw-mt-7">
                        <ContinueButton flat disabled={!page.address.address1} />
                        {/*<ContinueButton children={'Proceed'} onClick={page.nextStep} disabled={!page.address.address1} >Continue</ContinueButton>*/}
                      </div>
                    </AvForm>

                  </div>
                </div>
                <div className="tw-lg-w-1/2 tw-flex-auto">
                  <div style={{height:'100%'}} className="tw-hidden md:tw-block tw-w-full tw-h-full">
                    <img
                      src="/images/v2/buyers/shop-with-confidence1.png"
                      alt="Shop with confidence"
                      style={{height:'742px', width:'585px'}}
                      className="tw-h-[742px] tw-w-[585px]"
                    />
                  </div>
                  <div style={{height:'100%'}} className="tw-block md:tw-hidden tw-w-full tw-h-full">
                    <img
                      src="/images/v2/buyers/shop-with-confidence2.png"
                      alt="Shop with confidence"
                      style={{height:'517px'}}
                      className="tw-h-[517px] tw-w-full"
                    />
                  </div>
                </div>
              </div>
            </div>
          </Backdrop>
        </AppContent>



      </>
    );
  }),
);


